import { Component, OnInit, AfterViewInit} from '@angular/core';
import {environment} from '../environments/environment';
import { ApiService } from './services/api.service';
import { DashboardService } from './dashboard/services/dashboard.service';
import {CommentaryService} from "./commentary/services/commentary.service";
import { PdfSelectorComponent } from "./pdf-selector/pdf-selector.component"
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements  OnInit{
  title: string = 'Natural Gas Storage Dashboard';
  dashboardLastUpdated: Date = null;
  dashboardNextUpdate: Date = null;
  commentaryLastUpdated: Date = null;
  lastUpdateSubscription:any;
  commentaryLastUpdateSubscription:any;
  archiveReportSubscription:any;
  latestReport: any;
  justText: string = "Lorem ipsum homie. Just random text";


  constructor(private apiService: ApiService, private dashboardService: DashboardService, private commentaryService: CommentaryService){
    this.apiService.baseUrl = environment.apiUrl;
    this.apiService.contextPath = '';
  }

  ngOnInit() {

      $('.tourBox').fancybox({
          maxWidth	: 800,
          maxHeight	: '80%',
          minHeight: 400,
          fitToView	: false,
          width		: '70%',
          //height	: '85%',
          //autoSize	: false,
          autoHeight: true,
          closeClick	: false,
          openEffect	: 'none',
          closeEffect	: 'none',
          loop  : false


       /*   margin: [40, 0, 20, 0],
          maxWidth	: 800,
          maxHeight	: 600,
          fitToView	: false,
          width		: '70%',
          height		: '70%',
          autoSize	: false,
          closeClick	: false,
          openEffect	: 'none',
          closeEffect	: 'none',
        scrolling: 'visible',
        type: 'inline',
        width: 980,
          maxHeight: 2000,
        autoSize: false, // required for width
        margin: [40, 0, 20, 0],
        height: 'auto',
        padding: 0,
        fitToView: false,
        topRatio: 0,
        autoDimension: false*/
      });



    this.lastUpdateSubscription = this.dashboardService.getLastUpdated().subscribe(
      json =>{
        this.dashboardLastUpdated = new Date(json.dataLastUpdated);
        this.dashboardNextUpdate = new Date(json.dataNextUpdate);
      }, null, () =>{

      }
    )

    this.commentaryLastUpdateSubscription = this.commentaryService.getLastUpdated().subscribe(
      json =>{
        this.commentaryLastUpdated = new Date(json.lastUpdated);
      }, null, () =>{

      }
    )
    this.archiveReportSubscription = this.dashboardService.getArchiveReportByDate().subscribe(
      json => {
        this.latestReport = json;
        this.latestReport = json.length > 0 ? json[0] : null;
      }
    )
  }

  public printPage(){
      window.print();
  }

  public openLatestPDF() {
    window.open(this.apiService.baseUrl + this.latestReport.path, "_blank");
    this.dashboardService.getArchiveReportByDate()
  }


  ngAfterViewInit(){

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts